import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/partners-graphql/appEnv';

export default appStarterFactory(appEnv);
